    import React from 'react';
    import Slider from 'react-slick';
    import { SliderContainer, SlideImage } from './Slider.elements';

    import 'slick-carousel/slick/slick.css';
    import 'slick-carousel/slick/slick-theme.css';

    function ImageSlider({ data }) {
        const settings = {
            infinite: true,
            speed: 500,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
        };

        return (
            <SliderContainer>
                <Slider {...settings}>
                    {data.map((item, index) => (
                        <div key={index}>
                            <SlideImage src={item.img} alt={`Slide ${index + 1}`} />
                        </div>
                    ))}
                </Slider>
            </SliderContainer>
        );
    }

    export default ImageSlider;
